// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource';
import VueAnalytics from 'vue-analytics';
//import VueI18n from 'vue-i18n'

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faCoffee,
  faAngleUp,
  faAngleDown,
  faMinusCircle,
  faHome
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
require('../node_modules/bulma/css/bulma.css');

library.add(faCoffee, faAngleUp, faAngleDown, faMinusCircle, faHome);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueResource);
Vue.use(VueAnalytics, {id: 'UA-163698145-1', router});
Vue.config.productionTip = false;

/*
// Локалізація
const messages = {
  en: {
    message: {
      hello: 'hello, world'
    }
  },
  uk: {
    message: {
      hello: ' привіт, світ'
    }
  }
}

const i18n = new VueI18n({
  locale: 'uk',
  messages,
})
*/

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  //i18n,
  components: {
    App
  },
  template: '<App/>',
});

global.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js